export { MinimalHeader, type MinimalHeaderProps } from "./MinimalHeader";
